export default __webpack_public_path__ + "static/gitkraken_guidiff-96cff1c62969dffb9a0543c47fd74546.png";